import APIManager from "../../managers/APIManager";

export const SiteActions = {
  CREATE_SITE: "CREATE_SITE",
  GET_SITE: "GET_SITE",
  GET_SITE_REPORT: "GET_SITE_REPORT",
  GET_SITES: "GET_SITES",
  GET_SITES_LOADING: "GET_SITES_LOADING",
  INVALIDATE_SITES: "INVALIDATE_SITES",
  UPDATE_SITE: "UPDATE_SITE",
  SELECT_SITE: "SELECT_SITE",
  SELECT_SITE_LOADING: "SELECT_SITE_LOADING",
  SELECT_USER: "SELECT_USER",
  SELECT_USER_LOADING: "SELECT_USER_LOADING",
};

export const SiteActionCreators = {
  createSite: (site) => (dispatch) =>
    APIManager.createPlayer(site).then((res) =>
      dispatch({
        type: SiteActions.CREATE_SITE,
        payload: {
          site: res.data,
        },
      })
    ),
  getSite: (id) => (dispatch, getState) => {
    const sites = getState().site?.sites;
    const site = sites.find((site) => site.id === id);
    return new Promise((resolve, reject) => {
      dispatch({
        type: SiteActions.SELECT_SITE_LOADING,
        payload: true,
      });
      APIManager.getSite(id)
        .then((res) => {
          dispatch({
            type: SiteActions.SELECT_SITE,
            payload: {
              site: { ...res.data, videoCreation: site?.videoCreation },
            },
          });
          resolve(res);
        })
        .catch((err) => {
          console.error(err);
          reject(err);
        })
        .finally(() => {
          dispatch({
            type: SiteActions.SELECT_SITE_LOADING,
            payload: false,
          });
        });
    });
  },
  getSiteReport: (id, params) => (dispatch) =>
    APIManager.getSiteReport(id, params).then((res) =>
      dispatch({
        type: SiteActions.GET_SITE_REPORT,
        payload: {
          params,
          report: res.data,
        },
      })
    ),
  getSites: () => (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: SiteActions.GET_SITES_LOADING,
        payload: true,
      });
      APIManager.getSites()
        .then((res) => {
          dispatch({
            type: SiteActions.GET_SITES,
            payload: {
              sites: res.data,
              info: res.info,
            },
          });
          resolve(res);
        })
        .catch((err) => {
          console.error(err);
          reject(err);
        })
        .finally(() => {
          dispatch({
            type: SiteActions.GET_SITES_LOADING,
            payload: false,
          });
        });
    });
  },
  updateSite: (site) => (dispatch) =>
    APIManager.updatePlayer(site).then((res) =>
      dispatch({
        type: SiteActions.UPDATE_SITE,
        payload: {
          site: res.data,
        },
      })
    ),
  selectUser: (userId) => (dispatch, state) => {
    let user;
    if (userId === "all-users") {
      const apps = state().site?.info?.user?.apps;
      user = {
        id: "all-users",
        name: "All Users",
        app: apps,
        email: "",
      };
    } else {
      const appUsers = state().site?.info?.user?.appUsers;
      user = appUsers.find((user) => user.id === userId);
    }

    dispatch({
      type: SiteActions.SELECT_USER_LOADING,
      payload: true,
    });
    dispatch({
      type: SiteActions.SELECT_USER,
      payload: { user },
    });
    dispatch({
      type: SiteActions.SELECT_USER_LOADING,
      payload: false,
    });
  },
};
